import {
  COMPONENT_VALUE_TYPES as types,
  BACKGROUND_IMAGE_POSITION
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const propsSchema: PropsSchemaList = [
  {
    key: 'slides',
    label: 'Slides',
    type: types.ARRAY,
    children: [
      {
        key: 'imageGrid',
        label: 'Image Grid',
        type: types.ARRAY,
        options: {
          maxLength: 4
        },
        children: [
          {
            key: 'image',
            label: 'Image',
            type: types.S3_ASSET_URL,
            options: {
              cropEnabled: true,
              croppers: [
                {
                  name: 'mobile',
                  description: 'Mobile Screen (0px-600px)',
                  aspectRatio: undefined,
                },
                {
                  name: 'tablet',
                  description: 'Tablet Screen (601px-900px)',
                  aspectRatio: undefined,
                },
                {
                  name: 'desktop',
                  description: 'Desktop Screen (901px-1200+px)',
                  aspectRatio: undefined,
                },
              ],
            },
          },
          {
            key: 'position',
            label: 'Position',
            type: types.ENUM,
            options: BACKGROUND_IMAGE_POSITION
          },
        ]
      },
    ]
  },
  {
    key: 'height',
    label: 'Height',
    type: types.TEXT
  }
];

const defaultProps = {
  slides: [
    {
      imageGrid: [
        { image: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-01.jpg', position: 'CENTER' },
        { image: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-01.jpg', position: 'CENTER' },
        { image: 'https://genesis-cdn.ff.com/our_company/01_people/our-people-01.jpg', position: 'CENTER' },
      ]
    }
  ],
  height: '800px'
};

export default {
  title: 'MondrianGrid',
  id: 'MondrianGrid',
  propsSchema,
  defaultProps,
};
